async function getWorkflows() {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/getGitHubWorkflows`;

    const response = await fetch(apiUrl, {
        headers: {
            'x-functions-key': process.env.REACT_APP_FUNCTIONS_KEY,
        },
    });

    return response;
}

export { getWorkflows };
